import { DatePipe, DecimalPipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { Report } from 'app/models/report.model';
import { CalendarTranslateService } from 'app/modules/UIKit/services/calendarTranslate.service';
import { AuthService } from '../user/auth.service';
import { UtilityReport } from 'app/modules/UIKit/components/kontable/utility/utility-report';
import { REPORT_TYPE} from 'app/modules/UIKit/components/kontable/utility/utility-model';
import { CommonService } from '../utils/common.service';

declare var Stimulsoft: any;

/**
 * Questo è un service per la stampa e la visualizzazione di determinati template (che sono in assets/report)
 * all'interno di loyalty
 */

@Injectable()
export class LoyaltyPrintTemplateService {

  //Pagamento in cassa
  viewerPagamentoCassa: any;
  pagamentoCassaReport: any;
  konReport: Report;
  reportColumnType: REPORT_TYPE[] = undefined;
  viewer: any;
  columnWidth: number;

  selectedCompany: any;

  //konCassaReport: ReportPagamentoInCassa;
  showMeReport: boolean = false;
  iva = 1;

  constructor(
    private datePipe: DatePipe,
    private authService: AuthService,
    public srvCalendar: CalendarTranslateService,
    private decimalPipe: DecimalPipe,
    private utilityReport: UtilityReport,
    private commonService: CommonService
  ) { }


  /**
   * Metodo per visualizzare il modulo pdf nell'applicazione sul Browser
   */
  viewReportPagamentoCassa(){

  // Render report
  this.pagamentoCassaReport.render();
  this.showMeReport = true;

  this.viewerPagamentoCassa.report = this.pagamentoCassaReport;

  var self = this;

  setTimeout(() => {
    self.viewerPagamentoCassa.renderHtml('viewerContent');
    //eventuale controllo anche se inituile, l'oggetto se è undefined va impostato a true la seguente options  options.toolbar.showPrintButton = true;
    if(self.viewerPagamentoCassa.jsObject.controls.menus.printMenu != undefined){
      self.viewerPagamentoCassa.jsObject.controls.menus.printMenu.items["PrintPdf"].style.display = "none";
      self.viewerPagamentoCassa.jsObject.controls.menus.printMenu.items["PrintWithPreview"].style.display = "none";
    }
    self.addCloseButton();

    $('body').css('overflow', 'none');
  }, 100);

 }


 /**
  * Metodo per generare il report per il pagamento in cassa di uno specifico item
  * settate le opzioni per la renderizzazione, viene scelto il template e sosituite le
  * variabili all'interno del report con i dati del record passato come parametro
  * nel caso del barcode e del qrcode viene passato il valore da cui vengono generate le immagini
  * @param $event
  */
  generateReportPagamentoSpecific($event, prefixQrCode){

    // Report viewer options
    var options = new Stimulsoft.Viewer.StiViewerOptions();
    var dataText = new Stimulsoft.Report.Components.StiText();
    //options.appearance.openLinksWindow = '_blank';
    options.appearance.scrollbarsMode = true;
    options.appearance.fullScreenMode = true;
    options.toolbar.showSaveButton = false;

    options.toolbar.printDestination = 'Direct';
    dataText.textOptions.wordWrap = true;
    dataText.canGrow = true;
    dataText.margins.left = 10;
    dataText.margins.right = 10;
    dataText.margins.top = 10;
    dataText.margins.bottom = 10;

    this.viewerPagamentoCassa = new Stimulsoft.Viewer.StiViewer(options, 'StiViewer', false);

    this.pagamentoCassaReport = new Stimulsoft.Report.StiReport();

    // load resource file Report.mrt that is the report's design
    this.pagamentoCassaReport.loadFile('./assets/report/TemplatePagamentoInCassa.mrt');

    // retrive page info. We need to calculate the page width
    var page = this.pagamentoCassaReport.pages.getByIndex(0);

    //Variabile catalogo
    var catalog = this.pagamentoCassaReport.dictionary.variables.getByName('catalog');
    catalog.valueObject = $event.catalog_desc;

    //Variabile numero di reservation
    var numReservation = this.pagamentoCassaReport.dictionary.variables.getByName('num_res');
    numReservation.valueObject = `${$event['num_reservation']}`;

    //Variabile Data reservation, con formattazione YYYY-MM-DD
    var dtReservation = this.pagamentoCassaReport.dictionary.variables.getByName('dt_res');
    let date = Date.parse($event['dt_reservation']);
    if (date) {
      $event['dt_reservation'] = this.datePipe.transform($event['dt_reservation'],this.srvCalendar["calendars"][this.authService.sessionHelper.selectedLanguage].dateFormatFilter);
    }
    dtReservation.valueObject = $event['dt_reservation'];

    //Variabile del Cliente
    var customerReservation = this.pagamentoCassaReport.dictionary.variables.getByName('customer');
    customerReservation.valueObject = $event.cust_name + ' ' + $event.cust_surname;


    //Variabile per il totale della reservation senza IVA
    var totReservation = this.pagamentoCassaReport.dictionary.variables.getByName('tot_res');
    var tot = this.decimalPipe.transform($event.value/this.iva,"1.2-2");
    totReservation.valueObject = `${tot}`;


    //Variabile per il totale della reservation con IVA
    var totReservationIva = this.pagamentoCassaReport.dictionary.variables.getByName('tot_res_iva');
    totReservationIva.valueObject = `${$event.value.toFixed(2)}`;


    //Variabile per il prodotto
    var product = this.pagamentoCassaReport.dictionary.variables.getByName('product');
    product.valueObject = $event.gift_code + ' - ' + $event.gift_description;

    //ulteriore check card_no
    var cardNo = $event.card_no;
    if (cardNo===12 || cardNo.length===12)
      cardNo = this.commonService.getCardWithCheckdigit($event.card_no);

    //Variabile Barcode
    var barcode = this.pagamentoCassaReport.dictionary.variables.getByName('barcode');
    barcode.valueObject = cardNo;

    //Variabile QRCode
    var qrcode = this.pagamentoCassaReport.dictionary.variables.getByName('qr_code');
    qrcode.valueObject = prefixQrCode + '/' + cardNo + '/' + $event.barcode + '/' + 'END';

    this.viewReportPagamentoCassa();
  }



  /**
   * Metodo per generare il report per il pagamento in cassa di un premio digitale
   * settate le opzioni per la renderizzazione, viene scelto il template e sosituite le
   * variabili all'interno del report con i dati del record passato come parametro
   * @param $event
   */
  generateReportPagamentoDigitale($event){

    const self = this;

    // Aggiunte opzioni per la visualizzazione del pdf
    var options = new Stimulsoft.Viewer.StiViewerOptions();
    var dataText = new Stimulsoft.Report.Components.StiText();
    //options.appearance.openLinksWindow = '_blank';
    options.appearance.scrollbarsMode = true;
    options.appearance.fullScreenMode = true;
    options.toolbar.showSaveButton = false;
    options.toolbar.showPrintButton = true;
    options.toolbar.printDestination = 'Direct';
    dataText.textOptions.WordWrap = true;
    dataText.canGrow = true;
    dataText.margins.left = 10;
    dataText.margins.right = 10;
    dataText.margins.top = 10;
    dataText.margins.bottom = 10;

   this.selectedCompany = this.authService.user.selectedCompany;

    this.viewerPagamentoCassa = new Stimulsoft.Viewer.StiViewer(options, 'StiViewer', false);

    this.pagamentoCassaReport = new Stimulsoft.Report.StiReport();

    //Caricamento del template
    this.pagamentoCassaReport.loadFile('./assets/report/TemplatePagamentoInCassaDigitale.mrt');

    // retrive page info. We need to calculate the page width
    var page = this.pagamentoCassaReport.pages.getByIndex(0);

    //Variabile store
    var store = this.pagamentoCassaReport.dictionary.variables.getByName('store');
    store.valueObject = `${$event.store_host_code} - ${$event.store_desc}`

    //Variabile store address
    var storeAddress = this.pagamentoCassaReport.dictionary.variables.getByName('store_address');
    storeAddress.valueObject = $event.store_address;

    //Variabile store city
    var storeCity = this.pagamentoCassaReport.dictionary.variables.getByName('store_city');
    storeCity.valueObject = `${$event.store_zip_code} ${$event.store_city}`;

    //Variabile Data reservation, con formattazione YYYY-MM-DD
    var dtReservation = this.pagamentoCassaReport.dictionary.variables.getByName('var_date');
    let date = Date.parse($event['dt_reservation']);
    if (date) {
      $event['dt_reservation'] = this.datePipe.transform($event['dt_reservation'],this.srvCalendar["calendars"][this.authService.sessionHelper.selectedLanguage].dateFormatFilter);
    }
    dtReservation.valueObject = $event['dt_reservation'];

    //Logo pagina
    var logoImg = this.pagamentoCassaReport.dictionary.variables.getByName('var_logo');
    let stiImage = Stimulsoft.System.Drawing.Image.fromFile('./assets/layout/images/' + this.selectedCompany + '.png');
    console.log('./assets/layout/images/' + `${this.selectedCompany}` + '.png')
    logoImg.valueObject = stiImage;

    //Variabile protocollo pratica
    var protPratica = this.pagamentoCassaReport.dictionary.variables.getByName('var_protocol_prat');
    protPratica.valueObject = `${$event.num_reservation}`;

    //Variabile carta unika
    var card = this.pagamentoCassaReport.dictionary.variables.getByName('var_carta_unika');
    card.valueObject = `${$event.card_no}`;

    //Variabile codice cliente
    var codeCustomer = this.pagamentoCassaReport.dictionary.variables.getByName('var_code_cliente');
    codeCustomer.valueObject = `${$event.codice_cliente}`;

    //Variabile code accumulatore
    var acmCode = this.pagamentoCassaReport.dictionary.variables.getByName('var_accumulatore');
    acmCode.valueObject = `${$event.acm_code}`;

    //Variabile descrizione accumulatore
    var acmDesc = this.pagamentoCassaReport.dictionary.variables.getByName('var_desc_accum');
    acmDesc.valueObject = $event.acm_desc;

    //Variabile Customer
    var customer = this.pagamentoCassaReport.dictionary.variables.getByName('customer');
    customer.valueObject = $event.cust_name + ' ' + $event.cust_surname;

    //Variabile descrizione premio
    var descPremio = this.pagamentoCassaReport.dictionary.variables.getByName('var_desc_premio');
    descPremio.valueObject = $event.gift_description;

    //Variabile Contributo
    var contributo = this.pagamentoCassaReport.dictionary.variables.getByName('var_contributo');
    contributo.valueObject = `${$event.value.toFixed(2)}`;

    //Variabile punti item
    var punti = this.pagamentoCassaReport.dictionary.variables.getByName('var_punti');
    punti.valueObject = `${$event.points}`;

    //Variabile barcode
    var barcode = this.pagamentoCassaReport.dictionary.variables.getByName('var_ean_code');
    barcode.valueObject = `${$event.barcode}`;

    //Variabile saldo iniziale
    var pointsPre = this.pagamentoCassaReport.dictionary.variables.getByName('var_saldo_ini');
    pointsPre.valueObject = `${$event.points_pre}`;

    //Variabile punti usati
    var pointsUsed = this.pagamentoCassaReport.dictionary.variables.getByName('var_punti_usati');
    pointsUsed.valueObject = `${$event.points_used}`;

    //Variabile saldo finale
    var pointsFinal = this.pagamentoCassaReport.dictionary.variables.getByName('var_saldo_fin');
    pointsFinal.valueObject = `${$event.points_balance}`;

    this.viewReportPagamentoCassa();
  }



  /**
   * Metodo per generare il report per il pagamento in cassa dei premi di una reservation
   * settate le opzioni per la renderizzazione, viene scelto il template e sosituite le
   * variabili all'interno del report con i dati del record passato come parametro
   * @param $event un array di oggetti
   */
  generateReportPagamentoComplete($event){


    // Report viewer options
    var options = new Stimulsoft.Viewer.StiViewerOptions();
    var dataText = new Stimulsoft.Report.Components.StiText();
    //options.appearance.openLinksWindow = '_blank';
    options.appearance.scrollbarsMode = true;
    options.appearance.fullScreenMode = true;
    options.toolbar.showSaveButton = false;
    options.toolbar.showPrintButton = true;
    options.toolbar.printDestination = 'Direct';
    dataText.textOptions.wordWrap = true;
    dataText.canGrow = true;
    dataText.margins.left = 10;
    dataText.margins.right = 10;
    dataText.margins.top = 10;
    dataText.margins.bottom = 10;

    this.viewerPagamentoCassa = new Stimulsoft.Viewer.StiViewer(options, 'StiViewer', false);

    this.pagamentoCassaReport = new Stimulsoft.Report.StiReport();

    // load resource file Report.mrt that is the report's design
    this.pagamentoCassaReport.loadFile('./assets/report/TemplatePagamentoInCassaComplete.mrt');

    //Variabile Prodotto con relativa quantità
    var product = this.pagamentoCassaReport.dictionary.variables.getByName('product');
    var productStr = '';
    $event.forEach(el => {
      //Creazione stringa con i prodotti e le quantità relative
      productStr = productStr + ' ' + `<p style="display: flex; justify-content: space-between; width: 100%;"><span>${el.gift_description}</span> <span> - ${el.quantity}</span></p>`;
    });

    product.valueObject = productStr;

    //Variabile catalogo
    var catalog = this.pagamentoCassaReport.dictionary.variables.getByName('catalog');
    catalog.valueObject = $event[0].catalog_desc;

     //Variabile numero di reservation
     var numReservation = this.pagamentoCassaReport.dictionary.variables.getByName('num_res');
     numReservation.valueObject = `${$event[0].num_reservation}`;

     //Variabile Data reservation, con formattazione YYYY-MM-DD
     var dtReservation = this.pagamentoCassaReport.dictionary.variables.getByName('dt_res');
     let date = Date.parse($event[0].dt_reservation);
     if (date) {
       $event[0].dt_reservation = this.datePipe.transform($event[0].dt_reservation, this.srvCalendar["calendars"][this.authService.sessionHelper.selectedLanguage].dateFormatFilter);
     }
     dtReservation.valueObject = $event[0].dt_reservation;

     //Variabile del Cliente
     var customerReservation = this.pagamentoCassaReport.dictionary.variables.getByName('customer');
     customerReservation.valueObject = $event[0].cust_name + ' ' + $event[0].cust_surname;


     //Variabile per il totale della reservation senza IVA
     var totReservation = this.pagamentoCassaReport.dictionary.variables.getByName('tot_res');
     var totIva = 0;
     $event.forEach(el => {
       totIva = totIva + ((el.value.toFixed(2)*el.quantity)/this.iva);
     });

     var tot = this.decimalPipe.transform(totIva,"1.2-2");
     totReservation.valueObject = `${tot}`;


     //Variabile per il totale della reservation con IVA
     var totReservationIva = this.pagamentoCassaReport.dictionary.variables.getByName('tot_res_iva');
     var totNoIva = 0;
     $event.forEach(el => {
       totNoIva = totNoIva + (el.value.toFixed(2)*el.quantity);
     });
     var ivaTot = this.decimalPipe.transform(totNoIva, "1.2-2");
     totReservationIva.valueObject = `${ivaTot}`;

     //ulteriore check card_no
     var cardNo = $event[0].card_no;
     if (cardNo===12 || cardNo.length===12)
       cardNo = this.commonService.getCardWithCheckdigit($event[0].card_no);

     //Variabile Barcode
     var barcode = this.pagamentoCassaReport.dictionary.variables.getByName('barcode');
     barcode.valueObject = cardNo;

     //Variabile QRCode, con l'aggiunta di tutti i barcode dei premi prenotati
     var qrcode = this.pagamentoCassaReport.dictionary.variables.getByName('qr_code');
     var completeQr = '';
     $event.forEach(el => {
       //Aggiunto controllo per la quantità, nel caso che la quantità sia maggiore di 1 viene aggiunto n volte il barcode
      if(el.quantity >1 ){
        for(var i=0; i<el.quantity; i++ ){
          completeQr = completeQr + el.barcode + '/';
        }
      }else{
        completeQr = completeQr + el.barcode + '/';
      }
     });
     qrcode.valueObject = $event[0].prefix_qrcode + '/' + cardNo + '/' + completeQr + 'END';

    this.viewReportPagamentoCassa();
  }


  /**
   * Metodo per generare il report per il rimborso con contributo di un premio annullato
   * settate le opzioni per la renderizzazione, viene scelto il template e sosituite le
   * variabili all'interno del report con i dati del record passato come parametro
   * @param $event
   */
  generateReportRimborso($event){

    // Report viewer options
    var options = new Stimulsoft.Viewer.StiViewerOptions();
    var dataText = new Stimulsoft.Report.Components.StiText();
    //options.appearance.openLinksWindow = '_blank';
    options.appearance.scrollbarsMode = true;
    options.appearance.fullScreenMode = true;
    options.toolbar.showSaveButton = false;
    options.toolbar.showPrintButton = true;
    options.toolbar.printDestination = 'Direct';
    options.exports.showExportToPdf = true;

    dataText.textOptions.wordWrap = true;
    dataText.canGrow = true;
    dataText.margins.left = 10;
    dataText.margins.right = 10;
    dataText.margins.top = 10;
    dataText.margins.bottom = 10;

    this.viewerPagamentoCassa = new Stimulsoft.Viewer.StiViewer(options, 'StiViewer', false);

    this.pagamentoCassaReport = new Stimulsoft.Report.StiReport();

    // load resource file Report.mrt that is the report's design
    this.pagamentoCassaReport.loadFile('./assets/report/TemplateRimborso.mrt');

    //Variabile Catalog
    var catalog = this.pagamentoCassaReport.dictionary.variables.getByName('catalog');
    catalog.valueObject = $event.catalog_desc;

    //Variabile Num Reservation
    var numRes = this.pagamentoCassaReport.dictionary.variables.getByName('num_res');
    numRes.valueObject = `${$event.num_reservation}`;

    //Variabile Customer
    var customerReservation = this.pagamentoCassaReport.dictionary.variables.getByName('customer');
    customerReservation.valueObject = $event.cust_name + ' ' + $event.cust_surname;

    //Variabile Data reservation, con formattazione YYYY-MM-DD
    var dtReservation = this.pagamentoCassaReport.dictionary.variables.getByName('dt_res');
    let date = Date.parse($event['dt_reservation']);
    if (date) {
      $event['dt_reservation'] = this.datePipe.transform($event['dt_reservation'],this.srvCalendar["calendars"][this.authService.sessionHelper.selectedLanguage].dateFormatFilter);
    }
    dtReservation.valueObject = $event['dt_reservation'];

    //Variabile per il prodotto
    var product = this.pagamentoCassaReport.dictionary.variables.getByName('product');
    product.valueObject = $event.gift_description;

    //Variabile punti accreditati
    var pointsAcc = this.pagamentoCassaReport.dictionary.variables.getByName('punti_accr');
    pointsAcc.valueObject = `${$event.points}`;

    //Variabile prezo Unitario
    var przUnit = this.pagamentoCassaReport.dictionary.variables.getByName('prz_unit');
    przUnit.valueObject = `${$event.value.toFixed(2)}€`;

    //Variabile Barcode
    var barcode = this.pagamentoCassaReport.dictionary.variables.getByName('barcode');
    barcode.valueObject = $event.card_no;

    this.viewReportPagamentoCassa();
  }

  generateReportArticoloPronto($event, prefixQrCode){
    // Report viewer options
    var options = new Stimulsoft.Viewer.StiViewerOptions();
    var dataText = new Stimulsoft.Report.Components.StiText();
    //options.appearance.openLinksWindow = '_blank';
    options.appearance.scrollbarsMode = true;
    options.appearance.fullScreenMode = true;
    options.toolbar.showSaveButton = false;
    options.toolbar.showPrintButton = true;
    options.toolbar.printDestination = 'Direct';
    dataText.textOptions.wordWrap = true;
    dataText.canGrow = true;
    dataText.margins.left = 10;
    dataText.margins.right = 10;
    dataText.margins.top = 10;
    dataText.margins.bottom = 10;

    this.viewerPagamentoCassa = new Stimulsoft.Viewer.StiViewer(options, 'StiViewer', false);

    this.pagamentoCassaReport = new Stimulsoft.Report.StiReport();

    // load resource file Report.mrt that is the report's design
    this.pagamentoCassaReport.loadFile('./assets/report/TemplateArticoloPronto.mrt');

    // retrive page info. We need to calculate the page width
    var page = this.pagamentoCassaReport.pages.getByIndex(0);

    //Variabile catalogo
    var catalog = this.pagamentoCassaReport.dictionary.variables.getByName('catalog');
    catalog.valueObject = $event.catalog_desc;

    //Variabile numero di reservation
    var numReservation = this.pagamentoCassaReport.dictionary.variables.getByName('num_res');
    numReservation.valueObject = `${$event['num_reservation']}`;

    //Variabile Data reservation, con formattazione YYYY-MM-DD
    var dtReservation = this.pagamentoCassaReport.dictionary.variables.getByName('dt_res');
    let date = Date.parse($event['dt_reservation']);
    if (date) {
      $event['dt_reservation'] = this.datePipe.transform($event['dt_reservation'],this.srvCalendar["calendars"][this.authService.sessionHelper.selectedLanguage].dateFormatFilter);
    }
    dtReservation.valueObject = $event['dt_reservation'];

    //Variabile del Cliente
    var customerReservation = this.pagamentoCassaReport.dictionary.variables.getByName('customer');
    customerReservation.valueObject = $event.cust_name + ' ' + $event.cust_surname;


    //Variabile per il totale della reservation senza IVA
    var totReservation = this.pagamentoCassaReport.dictionary.variables.getByName('tot_res');
    var tot = this.decimalPipe.transform($event.value/this.iva,"1.2-2");
    totReservation.valueObject = `${tot}`;


    //Variabile per il totale della reservation con IVA
    var totReservationIva = this.pagamentoCassaReport.dictionary.variables.getByName('tot_res_iva');
    if($event.value!=null)
      totReservationIva.valueObject = `${$event.value.toFixed(2)}`;
    else  
      totReservationIva.valueObject = `0,00`;

    //Variabile per il prodotto
    var product = this.pagamentoCassaReport.dictionary.variables.getByName('product');
    product.valueObject = $event.gift_code + ' - ' + $event.gift_description;

    //ulteriore check card_no
    var cardNo = $event.card_no;
    
    if (cardNo===12 || cardNo.length===12)
      cardNo = this.commonService.getCardWithCheckdigit($event.card_no);

    //Variabile Barcode
    var barcode = this.pagamentoCassaReport.dictionary.variables.getByName('barcode');
    barcode.valueObject = cardNo;

    //Variabile QRCode
    var qrcode = this.pagamentoCassaReport.dictionary.variables.getByName('qr_code');
    qrcode.valueObject = prefixQrCode + '/' + cardNo + '/' + $event.barcode + '/' + 'END';

    this.viewReportPagamentoCassa();
  }


  /**
   * Metodo per la creazione di un bottone per la chiusura dell'applicazione viewer sul browser
   */
  addCloseButton() {

  const userButton = this.viewerPagamentoCassa.jsObject.SmallButton('userButton', 'Close', 'emptyImage');
  const self = this;
  userButton.action = function () {
    self.showMeReport = false;
      $('body').css('overflow', 'auto');
    }

  const toolbarTable = this.viewerPagamentoCassa.jsObject.controls.toolbar.firstChild.firstChild;
  const buttonsTable = toolbarTable.rows[0].lastChild.lastChild;
  const userButtonCell = buttonsTable.rows[0].insertCell(0);
  userButtonCell.className = 'stiJsViewerClearAllStyles';
  userButtonCell.appendChild(userButton);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/loyalty/loyalty-print-template.service.ts